import React from 'react';
import * as Styled from './navigationbarStyle';
import SubMenu from '../subMenu/subMenu';
import useMenus from '../../../hooks/useMenus';
import MobileNavbar from './mobileNavigation';
import { Row } from 'react-bootstrap';
import { addTrailingSlash, isExternalUrlhref } from '../../../utils';

const BootstrapNavbar = (props) => {
  const [showSubMenu, setShowSubMenu] = React.useState(false);
  const [menuDetails, setMenuDetails] = React.useState({});
  const [hoverIndex, setHoverIndex] = React.useState();

  const menu = useMenus();
  const onMouseEnter = (key, index) => {
    setMenuDetails(
      menu.navigations.filter((item) => item.entryWithPath?.text === key)[0]
    );
    setShowSubMenu(
      !!menu.navigations.filter(
        (item) => item.entryWithPath?.text === key && item.subNavigations
      )[0]
    );
    setHoverIndex(index);
  };

  const onMouseLeave = () => {
    setShowSubMenu(false);
    setHoverIndex(null);
  };

  return (
    <React.Fragment>
      <div className="d-none d-md-block" onMouseLeave={(e) => onMouseLeave()}>
        <Styled.MainContainer>
          <Styled.TopLogoAnchor
            href={addTrailingSlash(process.env.GATSBY_DOMAIN_URL)}
          >
            <Styled.TopLogo
              src={menu?.imageWithPath[0]?.image?.file?.url}
              title={menu?.imageWithPath[0]?.title}
            />
          </Styled.TopLogoAnchor>
          <Styled.TopNav>
            {menu?.navigations?.map((item, index) => {
              return (
                <Styled.ListDiv key={index}>
                  <Styled.HeaderMenu
                    onMouseEnter={(e) => {
                      onMouseEnter(item?.entryWithPath?.text, index);
                    }}
                    onMouseOut={() => {
                      !item?.subNavigations && onMouseLeave();
                    }}
                    href={
                      isExternalUrlhref(item?.entryWithPath?.path)
                        ? item?.entryWithPath?.path
                        : addTrailingSlash(
                            process.env.GATSBY_DOMAIN_URL +
                              item?.entryWithPath?.path
                          )
                    }
                    className={
                      item?.type === props.activeLink
                        ? 'active'
                        : hoverIndex === index && 'hoverEffect'
                    }
                  >
                    {item?.entryWithPath?.text}
                  </Styled.HeaderMenu>
                  {showSubMenu && hoverIndex === index && (
                    <SubMenu
                      onMouseLeave={(e) => onMouseLeave()}
                      onMouseEnter={(e) => onMouseEnter('')}
                      menuDetails={menuDetails}
                    />
                  )}
                </Styled.ListDiv>
              );
            })}
          </Styled.TopNav>
        </Styled.MainContainer>
      </div>
      <div className="d-block d-md-none">
        <MobileNavbar />
      </div>
      <div style={{ clear: 'both' }}></div>
    </React.Fragment>
  );
};

export default BootstrapNavbar;
